"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/environmentSelectionController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var EnvironmentSelectioController = function () {
        function EnvironmentSelectioController() {
            _classCallCheck(this, EnvironmentSelectioController);

            this.environmentSelectionPrefix = '/api/Environment/';
        }

        _createClass(EnvironmentSelectioController, [{
            key: "getEnvironmentsForUser",
            value: function getEnvironmentsForUser() {
                return abortingRequest.send(this.environmentSelectionPrefix + 'GetEnvironmentsForUser', ajaxSettingsProvider.httpPost(), false, false);
            }
        }]);

        return EnvironmentSelectioController;
    }();

    return new EnvironmentSelectioController();
});
//# sourceMappingURL=environmentSelectionController.js.map;
